export const sortList = arr => {
  return [...arr].sort((a, b) => parseInt(b.number) - parseInt(a.number));
};
